const isSafeTarget = (target) => target === "_self" || target === "_blank";
function addRelAndTarget(target) {
  const safeTarget = isSafeTarget(target) ? target : "_self";
  const rel = safeTarget === "_blank" ? "noopener noreferrer" : void 0;
  return { target: safeTarget, ...rel && { rel } };
}
export {
  addRelAndTarget as a
};
//# sourceMappingURL=addRelAndTarget.DDvAIEJJ.mjs.map
